import NextLink from 'next/link';
import { useRouter } from 'next/router';

import React from 'react';

import styled from 'styled-components';

import { ArrowWithTailIcon } from '@components/common/FormIcon';

import { LinkProps } from '@customTypes/Link';

const Wrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;

  .icon {
    margin-left: 0.4em;
    transform: translateY(0.07em);
  }
  &.btn {
    display: inline-flex;

    .icon {
      display: none;
    }
  }
  font-size: 14px;
  @media (min-width: 992px) {
    font-size: 16px;
  }
  font-weight: 500;
  &:not(.btn) {
    color: #a3a7ae;
  }
`;

function purePath(path: string) {
  return path?.split('?')[0].split('#')[0].replace(/\/$/, '');
}

export const ActionableLink: React.FC<{
  href: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  children: React.ReactNode;
}> = (props) => {
  const router = useRouter();
  const { children, href, className, onClick } = props;
  const isNavigateOutside = purePath(href) !== purePath(router.asPath);
  if (!href) return null;
  return (
    <NextLink
      // prettier-ignore
      className={className}
      href={href}
      shallow={!isNavigateOutside}
      scroll={isNavigateOutside}
      replace={isNavigateOutside}
      onClick={onClick}
    >
      {children}
    </NextLink>
  );
};

export const Link: React.FC<LinkProps> = (props) => {
  const { name, href, className, hasArrow, onClick } = props;

  return (
    <ActionableLink href={href} onClick={onClick}>
      <Wrapper className={`link ${className ? className : ''}`}>
        <div className="label">{name}</div>
        <div className="icon">
          <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 11.72L6 6.27046L1 0.720001" stroke="#A3A7AE" strokeWidth="2" />
          </svg>
        </div>
        {hasArrow ? <ArrowWithTailIcon style={{ paddingLeft: '3px' }} /> : null}
      </Wrapper>
    </ActionableLink>
  );
};
